import React from "react"
import { Col, Row } from "react-bootstrap"
import MisCohortes from "./MisCohortes"

const Home = (props) => {
  return (
    <Row>
      <Col xs={12}>
        <MisCohortes />
      </Col>
    </Row>
  )
}

export default Home
